import ModernShell from "../../components/ModernShell";
import RefereeCalendarComp from "../../components/RefereeCalendarComp";

const RefereeCalendar = () => {
  return (
    <ModernShell title="Calendar" subtitle="See every upcoming assignment at a glance.">
      <RefereeCalendarComp />
    </ModernShell>
  );
};

export default RefereeCalendar;
